"use strict";

import "./Summary.css";
import React from "react";
import Card from "vwa/components/Card";
import Pin from "vwa/components/Pin";
import Icon from "vwa/components/Icon";
import Table from "./Table";

import {
	getPositionOfVehicle,
	getAddressOfVehicle,
	getMovingStateOfVehicle,
	hasStateOfVehicle,
	getLastTimeOfVehicleState
} from "./../../../utils/vehicle";

export default class Summary extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			expanded: this.props.expanded
		};
	}
	
	getTitle() {
		return this.props.vehicle.name ? this.props.vehicle.name : this.props.vehicle.plateNumber;
	}
	
	getSubTitle() {
		if (this.getTitle() == this.props.vehicle.plateNumber)
			return "";
		else
			return this.props.vehicle.plateNumber || "";
	}
	
	getLastTime() {
		return getLastTimeOfVehicleState(this.props.vehicle._id);
	}
	
	toggle() {
		this.setState({
			expanded: !this.state.expanded
		});
	}
	
	createTouchProps() {
		
		let pressStarted = false;
		
		return {
			onTouchStart: () => {
				pressStarted = true;
				setTimeout(() => {
					if (pressStarted)
						this.props.onSwitchVehicleDetails();
					pressStarted = false;
				}, 1000);
			},
			onTouchEnd: () => {
				pressStarted = false;
			},
			onTouchCancel: () => {
				pressStarted = false;
			}
		};
	}
	
	renderPin() {
		if (hasStateOfVehicle(this.props.vehicle._id) && getPositionOfVehicle(this.props.vehicle._id)) {
			return <Pin
						checked={this.props.pinned}
						onChange={value => this.props.onPinChange(value)}
					/>
		}
	}
	
	renderLastTime() {
		const lastTime = this.getLastTime();
		
		if (lastTime)
			return <label>{(new Date(lastTime)).toLocaleString()}</label>;
		else
			return null;
	}
	
	renderHeader() {
		return (
			<header>
				<div>
					<div id="nameContainer">
						<h1 onClick={evt => {
							evt.stopPropagation();
							this.props.onSwitchVehicleDetails();
						}}>{this.getTitle()}</h1>
						<h2>{this.getSubTitle()}</h2>
					</div>
					{this.renderPin()}
				</div>
				<div>
					{this.renderLastTime()}
					<label>{getAddressOfVehicle(this.props.vehicle._id)}</label>
				</div>
			</header>
		);
	}
	
	renderTable() {
		return (
			<Table
				shown={this.state.expanded}
				vehicle={this.props.vehicle}
			/>
		);
	}
	
	renderFooter() {
		
		const className = hasStateOfVehicle(this.props.vehicle._id) != 0 ? "" : "Hidden";
		
		return (
			<footer
				className={className}
				onClick={evt => {evt.stopPropagation(); this.toggle();}}
			>
				&bull;&bull;&bull;
			</footer>
		);
	}
	
	render() {
		
		const touchProps = this.createTouchProps();
		
		return (
			<Card className="Summary" onClick={_ => this.props.onFocus()} onDoubleClick={ this.props.onSwitchVehicleDetails } {...touchProps}>
				<div id="ignitionMarker" className={getMovingStateOfVehicle(this.props.vehicle._id)}/>
				{this.renderHeader()}
				{this.renderTable()}
				{this.renderFooter()}
			</Card>
		);
	}
	
}

Summary.propTypes = {
	vehicle:				React.PropTypes.object.isRequired,
	pinned:					React.PropTypes.bool,
	onFocus:				React.PropTypes.func,
	onSwitchVehicleDetails:	React.PropTypes.func,
	onPinChange:			React.PropTypes.func,
	expanded:				React.PropTypes.bool
};

Summary.defaultProps = {
	expanded:				false,
	onFocus:				() => {},
	onSwitchVehicleDetails:	() => {},
	onPinChange:			value => {}
};


// WEBPACK FOOTER //
// ./src/view/VehicleList/Summary/Summary.jsx